import './Spinner.css'

export type SpinnerProps = {
  /** Diameter in px. Defaults to 20. */
  size?: number
  className?: string
  /**
   * Decorative spinners (e.g. inside a Button that already announces its
   * loading state) skip the role/hidden text.
   */
  decorative?: boolean
}

export function Spinner({ size = 20, className, decorative = false }: SpinnerProps) {
  if (decorative) {
    return <span className={`ui-spinner${className ? ` ${className}` : ''}`} style={{ width: size, height: size }} aria-hidden="true" />
  }
  return (
    <span className={`ui-spinner${className ? ` ${className}` : ''}`} style={{ width: size, height: size }} role="status">
      <span className="visually-hidden">Laden…</span>
    </span>
  )
}
